<template>
  <div>
    <div>
      <p><b>עיר עבודה (1)</b></p>
      <input @input="searchCitiesByTerm($event.target.value)" v-model="search_term" class="outlined" placeholder="אנא הקלד/י עיר עבודה...">
    </div>
    <div class="search_results">
      <p v-for="city_result in cities_search_results" :key="city_result.CityID" @click="pickCity(city_result)" class="search_result">{{city_result.CityName}}</p>
    </div>
    <div>
      <div v-for="picked_city in picked_cities" :key="picked_city.CityID"
           class="is-flex is-align-items-center is-justify-content-space-between faded_border_bottom" style="width: 310px; margin-top: 10px;">
        <p>{{picked_city.CityName}}</p>
        <a @click="removePickedCity(picked_city)" class="button is-danger">הסר</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'outsource-all-jobs-cities',
  props: ['cities', 'picked_cities'],
  data () {
    return {
      cities_search_results: [],
      search_term: ''
    }
  },
  methods: {
    searchCitiesByTerm (term) {
      if (term.length == 0) {
        this.cities_search_results = []
        return
      }
      this.cities_search_results = this.cities.filter(city => city.CityName.toLowerCase().includes(term.toLowerCase()))
    },
    pickCity (picked_city) {
      this.cities_search_results = []
      this.search_term = ''
      if (this.picked_cities.filter(city => city.CityID == picked_city.CityID)[0] != undefined) {
        return
      }
      let picked_cities = [...this.picked_cities]
      picked_cities.push(picked_city)
      this.$emit('input', picked_cities)
    },
    removePickedCity (city_to_remove) {
      let picked_cities = this.picked_cities.filter(picked_city => picked_city.CityID != city_to_remove.CityID)
      this.$emit('input', picked_cities)
    }
  }
}
</script>
